// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xR7RnHgfeKD858,
.xR7RnHgfeKD858 td {
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-0, 0);
  border: none;
}
.xR7RnHgfeKD858 thead {
  position: absolute;
  width: 1px;
  height: 1px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: -1px;
  padding: var(--ds-space-0, 0);
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
  word-wrap: normal;
  white-space: nowrap;
}
.xR7RnHgfeKD858 tr.dv3MvTwHfwVKYn {
  border: none;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.xR7RnHgfeKD858 td.EGGvAXgjP211E5 {
  padding: var(--ds-space-100, 8px) var(--ds-space-500, 40px);
}
.xR7RnHgfeKD858 td._3vzYg9jAiuynF {
  text-align: right;
  white-space: nowrap;
}
.tqPBTdj9zn6KhZ {
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
.tqPBTdj9zn6KhZ p {
  margin-right: var(--ds-space-150, 10px);
  margin-left: var(--ds-space-150, 10px);
}
.VvE5W00Qon4JMD {
  position: absolute;
  right: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var billingHistoryTable = `xR7RnHgfeKD858`;
export var statement = `dv3MvTwHfwVKYn`;
export var description = `EGGvAXgjP211E5`;
export var amount = `_3vzYg9jAiuynF`;
export var pagination = `tqPBTdj9zn6KhZ`;
export var showAll = `VvE5W00Qon4JMD`;
export default ___CSS_LOADER_EXPORT___;
